// extracted by mini-css-extract-plugin
export default {"left_s":"product_left_s__UuN+a","name":"product_name__Vzmxj","img_p":"product_img_p__3XHnI"};